import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AreaLocalProvider } from '../area-local/area-local';
import { BrComService } from '../../service/BrComService';
import { HttpServidor } from '../shared/abstract/http-servidor';
import { Mensagem, TipoMensagem, OrigemMensagem, ArquivoMensagem } from '../../models/mensagem';
import { ContatoLocalProvider } from '../contato-local/contato-local';

import * as firebase from "firebase";

export interface PayloadMensagemSimples {
  idEnvio: number,
  idMensagemUsuario: number,
  idUsuarioOrigem: number, 
  idUsuarioDestino: number, 
  mensagem: string, 
  textoTipoMensagem: string,
  podeSerRespondida: boolean,
  origem: OrigemMensagem
}

export interface PayloadMensagem {
  idEnvio: number,
  idMensagemUsuario: number,
  idArea?: number,
  idContato?: number,
  idUsuarioOrigem: number, 
  idUsuarioDestino: number, 
  mensagem: string, 
  textoTipoMensagem: string,
  podeSerRespondida: boolean,
  origem: OrigemMensagem,
}

export interface PayloadMensagemImagem {
  idEnvio: number,
  idMensagemUsuario: number,
  idArea?: number,
  idContato?: number,
  idUsuarioOrigem: number,
  idUsuarioDestino: number, 
  link: string,
  podeSerRespondida: boolean,
  textoTipoMensagem: string,
  origem: OrigemMensagem,
}

export interface PayloadMensagemArquivo {
  idEnvio: number,
  idMensagemUsuario: number,
  idArea?: number,
  idContato?: number,
  idUsuarioOrigem: number,
  idUsuarioDestino: number, 
  arquivo: ArquivoMensagem,
  podeSerRespondida: boolean,
  textoTipoMensagem: string,
  origem: OrigemMensagem,
}

export interface PayloadMensagemResposta extends PayloadMensagem{
  nomeUsuario: string;
  hashLogotipo: string;
}

export interface PayloadMensagemLink extends PayloadMensagem{
  link: string;
  labelLink: string
}

export interface PayloadMensagemHTML extends PayloadMensagem{
  hashHTML: string;
  mensagemTexto: string;
  mensagemResumo: string;
  labelLink: string;
  link: string;
}

@Injectable()
export class MensagemProvider extends HttpServidor {
  
  private fireStorage: firebase.storage.Storage;

  constructor(http: HttpClient, 
    private datePipe: DatePipe, 
    private brComService: BrComService, 
    private areaLocalProvider: AreaLocalProvider, 
    private contatoLocalProvider: ContatoLocalProvider) {
    super(http)
    this.fireStorage = firebase.initializeApp({
      apiKey: "AIzaSyBDsDg50soYL8s24mv34lk5I3oKdJcmpJI",
      authDomain: "brcomunique2.firebaseapp.com",
      databaseURL: "https://brcomunique2.firebaseio.com",
      projectId: "brcomunique2",
      storageBucket: "brcomunique2.appspot.com",
      messagingSenderId: "109453559228"
    }, "brcomunique").storage();
  }

  private getDataHoraFormatado(): any {
    const date = new Date();
    const data = this.datePipe.transform(date, 'dd/MM/yyy');
    const hora = this.datePipe.transform(date, 'HH:mm');
    return {data, hora}
  }

  private corrigirMensagem(mensagem: Mensagem, tipo: TipoMensagem): Mensagem {
    const dataHora = this.getDataHoraFormatado();
    mensagem.tipo = tipo;
    mensagem.statusMensagemLida = false;
    mensagem.statusMensagemRecebida = false;
    mensagem.data = dataHora.data;
    mensagem.hora = dataHora.hora;
    return mensagem;
  }

  public criarMensagemImagem(payload: PayloadMensagemImagem): Mensagem {
    return this.corrigirMensagem(payload as Mensagem, TipoMensagem.IMAGEM);
  }

  public criarMensagemArquivo(payload: PayloadMensagemArquivo): Mensagem {
    return this.corrigirMensagem(payload as Mensagem, TipoMensagem.ARQUIVO)
  }

  public criarMensagemSimples(payload: PayloadMensagemSimples): Mensagem {
    return this.corrigirMensagem(payload as Mensagem, TipoMensagem.SIMPLES);
  }

  public criarMensagemResposta(payload: PayloadMensagemResposta): Mensagem {
   return this.corrigirMensagem(payload as Mensagem, TipoMensagem.RESPOSTA);
  }

  public criarMensagemLink(payload: PayloadMensagemLink): Mensagem {
    return this.corrigirMensagem(payload as Mensagem, TipoMensagem.LINK);
  }

  public criarMensagemHTML(payload: PayloadMensagemHTML): Mensagem {
    payload.mensagemTexto = payload.mensagem;
    delete payload.mensagem;
    return this.corrigirMensagem(payload as Mensagem, TipoMensagem.HTML);
  }

  public criarMensagemFacebook(payload: PayloadMensagemLink): Mensagem {
    return this.corrigirMensagem(payload as Mensagem, TipoMensagem.FACEBOOK);
  }

  public getDateMensagem(mensagem: Mensagem): Date {
    const data = mensagem.data.split('/');
    const hora = mensagem.hora.split(':');
    return new Date(+data[2], +data[1] - 1, +data[0], +hora[0], +hora[1]);
  }

  public notificarMensagemRecebida(mensagem: Mensagem): Observable<void> {
    const form = new FormData();
    form.append('id_mensagem_usuario', String(mensagem.idMensagemUsuario));
    form.append('id_device', String(this.brComService.getIdDevice()));
    return this.post('registraMensagemRecebida', form);
  }

  public async uploadFirebase(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.fireStorage.ref(new Date().getTime().toString()).put(blob).then(
        (res) => {
          res.ref.getDownloadURL().then(
            (url) => {
              resolve(url)
            }, error => {
              reject(error)
            }
          )
        }, error => {
          reject(error);
        }
      )
      /*
      this.fireStorage.upload(new Date().getTime().toString(), blob).then(
        (res) => {
          res.ref.getDownloadURL().then(
            (url) => {
              resolve(url)
            }, error => {
              reject(error)
            }
          )
        }, error => {
          reject(error);
        }
      );*/
    })
  }

  public notificarMensagensRecebidasPendentes(): void {
    /*const mensagensContatoComRecibimentoPendente = this.contatoLocalProvider.getMensagensComRecebimentoPendente() || [];
    const mensagemAreaComRecebimentoPendente = this.areaLocalProvider.getMensagensComRecebimentoPendente() || [];
    const mensagensComRecebimentoPendente = mensagensContatoComRecibimentoPendente.concat(mensagemAreaComRecebimentoPendente);
    for (const mensagem of mensagensComRecebimentoPendente) {
      this.notificarMensagemRecebida(mensagem);
    }*/
  }

  public notificarMensagemLida(mensagens: Mensagem[]): void {
    /*const idMensagensUsuarios = mensagens.map(m => m.idMensagemUsuario);
    const form = new FormData();
    form.append('id_mensagem_usuarios',  JSON.stringify(idMensagensUsuarios));
    form.append('id_device', String(this.brComService.getIdDevice()));
    this.post('registraMensagensLidas', form).subscribe();*/
  }

}



// WEBPACK FOOTER //
// ./src/providers/mensagem/mensagem.ts